{
  "REPORTS": {
    "REPORTS": "Reports",
    "GENERATE_REPORT": "Generate report",
    "NO_REPORT_SELECTED": "No report selected...",
    "GENERATING_REPORT": "Generating report",
    "ERROR_WHEN_GENERATING": "Error when generating report",
    "SEARCH": "Search..."
  }
}